import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {z as zod} from "zod";

/** Admin review-queue DTO for customer-submitted category requests. */
export type OttokartCustomerCategoryRequestReviewItem = {
    id: Uuid;
    createdAt: Iso8601DateTime;
    updatedAt: Iso8601DateTime;
    customerId: Uuid;
    category: string;
    customerName: string | null;
};

export const ottokartCustomerCategoryRequestReviewItemValidator: zod.ZodType<OttokartCustomerCategoryRequestReviewItem> =
    zod.object({
        id: uuidZodValidator,
        createdAt: iso8601DateTimeZodValidator,
        updatedAt: iso8601DateTimeZodValidator,
        customerId: uuidZodValidator,
        category: zod.string(),
        customerName: zod.string().nullable(),
    });

/** Admin review-queue DTO for new fleet machine requests (`is_new = true`). */
export type OttokartNewFleetMachineReviewItem = {
    id: Uuid;
    modelNo: string | null;
    approvalStatus: string | null;
    manufacturer: string | null;
    machineType: string | null;
    createdAt: Iso8601DateTime;
    customerId: Uuid;
    customerName: string | null;
};

export const ottokartNewFleetMachineReviewItemValidator: zod.ZodType<OttokartNewFleetMachineReviewItem> = zod.object({
    id: uuidZodValidator,
    modelNo: zod.string().nullable(),
    approvalStatus: zod.string().nullable(),
    manufacturer: zod.string().nullable(),
    machineType: zod.string().nullable(),
    createdAt: iso8601DateTimeZodValidator,
    customerId: uuidZodValidator,
    customerName: zod.string().nullable(),
});
